import { render } from "./BaseValueMetric.vue?vue&type=template&id=38f4726e"
import script from "./BaseValueMetric.vue?vue&type=script&lang=js"
export * from "./BaseValueMetric.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BaseValueMetric.vue"]])

export default __exports__